import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
import logo from '../../assets/img/illustrations/logo.png';
import logoBordered from '../../assets/img/illustrations/logo-bordered.png';
import photo from '../../assets/img/generic/condominium.jpg';

const highlights = [
  'Cobros, gastos y recibos de tu condominio en un solo lugar.',
  'Cada propietario ve su saldo y paga en minutos.',
  'Cuentas claras y al día, mes a mes.',
];

// Pantallas de acceso (login, registro, recuperar contraseña): panel de marca
// oscuro y redondeado a la izquierda (con la foto del condominio apenas
// visible de fondo), y el formulario sobre fondo blanco a la
// derecha. En pantallas chicas solo queda el formulario con el logo arriba.
const AuthShell = ({ wide = false, children }) => (
  <div className="hl-auth">
    <aside className="hl-auth__brand hl-story" style={{ '--hl-auth-photo': `url(${photo})` }}>
      <Link to="/" className="hl-auth__brand-logo" aria-label="Homelan">
        <img src={logoBordered} alt="Homelan" width={128} />
      </Link>

      <div className="hl-auth__copy">
        <h1 className="hl-auth__headline">La administración de tu condominio, simple y transparente.</h1>
        <ul className="hl-auth__highlights">
          {highlights.map(text => (
            <li key={text} className="hl-story__muted">
              <span className="hl-auth__check" aria-hidden="true">
                <Check size={11} strokeWidth={3} color="#fff" />
              </span>
              {text}
            </li>
          ))}
        </ul>
      </div>
    </aside>

    <main className="hl-auth__main">
      <div className={classNames('hl-auth__panel', { 'hl-auth__panel--wide': wide })}>
        <Link to="/" className="hl-auth__mobile-logo" aria-label="Homelan">
          <img src={logo} alt="Homelan" width={128} />
        </Link>
        {children}
      </div>
    </main>
  </div>
);

AuthShell.propTypes = {
  wide: PropTypes.bool,
  children: PropTypes.node,
};

export default AuthShell;
